// extracted by mini-css-extract-plugin
module.exports = {"link":"link-3fa205","block":"block-3fa205","title":"title-3fa205","group":"group-3fa205","groupTitle":"groupTitle-3fa205"};